import React from "react"
export function Sms(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16.017 2C17.112 2 18 2.866 18 3.934v8.718l-.006.151c-.079.998-.934 1.783-1.977 1.783H9.16l-3.255 3.19-.08.069c-.493.372-1.243.037-1.243-.602v-2.657h-.598C2.888 14.586 2 13.72 2 12.652V3.934C2 2.866 2.888 2 3.983 2h12.034zm0 1.51H3.983a.43.43 0 00-.435.424v8.718a.43.43 0 00.435.424h1.372l.105.007c.378.05.669.366.669.748v1.583l2.159-2.116a.784.784 0 01.549-.222h7.18a.43.43 0 00.435-.424V3.934a.43.43 0 00-.435-.424zM11.29 8.433v1.51H5.61v-1.51h5.678zm2.58-3.02v1.51H5.611v-1.51h8.258z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__sms"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
